import { useState } from "react";
import BrandMark from "./BrandMark";

export default function BrandLogo({ compact = false }) {
  const [hasError, setHasError] = useState(false);
  const assetPath = "/affitrack-logo.svg";

  if (!hasError) {
    return (
      <img
        alt="AffiTrack"
        className={compact ? "brand-logo-image brand-logo-image-compact" : "brand-logo-image"}
        onError={() => setHasError(true)}
        src={assetPath}
      />
    );
  }

  return (
    <div className={compact ? "brand-logo-fallback brand-logo-fallback-compact" : "brand-logo-fallback"}>
      <BrandMark size={compact ? "small" : "large"} />
      <div className="brand-logo-copy">
        <div className={compact ? "brand-logo-type brand-logo-type-compact" : "brand-logo-type"}>
          <span className="brand-word brand-word-dark">Affi</span>
          <span className="brand-word brand-word-gold">Track</span>
        </div>
        {!compact ? <div className="brand-logo-caption">Track. Analyze. Grow.</div> : null}
      </div>
    </div>
  );
}
